<template>
  <v-form v-model="valid" ref="WalletForm" lazy-validation>
    <v-container grid-list-xs>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="Description"
            v-model="description"
            :rules="descriptionRules"
            required
            />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Wallet Address"
            v-model="walletAddress"
            :rules="walletRules"
            :error-messages="walletErrors"
            required
          />
        </v-flex>
        <v-flex xs12>
          <v-select
            label="Pool"
            :items="poolNames"
            v-model="selectedPool"
            :rules="poolRules"
            required
          />
        </v-flex>
        <v-flex xs12>
          <v-select
            label="Coin"
            :items="coinNames"
            v-model="selectedCoin"
            :rules="coinRules"
            :disabled="selectedPool === ''"
            required
          />
        </v-flex>
        <v-flex xs12 v-if="!isFirstWallet">
          <v-switch
            label="Set as default"
            v-model="defaultWallet" />
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" @click="AddWallet">
            <looping-rhombuses-spinner
              :animation-duration="2500"
              :rhombus-size="10"
              color="#fff"
              v-if="loading"
            />
            <span v-else>Add</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { LoopingRhombusesSpinner } from 'epic-spinners';
  export default {
    components: {
      LoopingRhombusesSpinner
    },
    computed: {
      ...mapGetters({
        loading: 'wallet/GET_LOADING',
        wallets: 'wallet/GET_WALLETS'
      }),
      coinNames () {
        switch (this.selectedPool) {
          case 'Bitfly':
            return [
              {text: 'ETH'},
              {text: 'ETC'},
              {text: 'ZEC'}
            ];
          case 'Luxor':
            return [
              {text: 'SC'},
              {text: 'DCR'},
              {text: 'LBC'},
              {text: 'LOKI'},
              {text: 'AION'},
              {text: 'XMR'},
              {text: 'ZEC'},
              {text: 'ZEN'},
              {text: 'SPACE'},
            ];
        }
        return [];
      },
      isFirstWallet () {
        return this.wallets === null || this.wallets.length === 0;
      }
    },
    data: () => ({
      valid: false,
      description: '',
      descriptionRules: [
        v => !!v || 'Description is required',
      ],
      walletAddress: '',
      walletRules: [
        v => !!v || 'Wallet is required',
      ],
      walletErrors: [],
      selectedPool: '',
      poolRules: [
        v => !!v || 'Pool is required',
      ],
      selectedCoin: '',
      coinRules: [
        v => !!v || 'Coin is required',
      ],
      defaultWallet: false,
      poolNames: [
        {text: 'Bitfly' },
        {text: 'Luxor' }
      ]
    }),
    methods: {
      AddWallet () {
        if (this.$refs.WalletForm.validate() ){
          let payload = {
            default: this.isFirstWallet ? 1 : (this.defaultWallet ? 1 : 0),
            walletAddress: this.walletAddress,
            description: this.description,
            poolName: this.selectedPool,
            coinName: this.selectedCoin
          };
          //console.log(payload);
          this.$store.dispatch('wallet/STORE_WALLET', payload)
            .then(() => {
              this.$emit('STORE_WALLET_SUCCESS');
              this.$refs.WalletForm.reset();
              if (this.isFirstWallet) {
                //this.$store.dispatch('wallet/FETCH_WALLET_DATA', {walletAddress: this.walletAddress});
              }
            })
            .catch(error => {
              if (error.status === 409) {
                this.walletErrors = [error.data.message]
              }
            });
        }
      }
    }
  }
</script>
